import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/TextPage.css';
import { getApiUrl } from "../utils/config";
import Cookies from "js-cookie";

const TelegramEntryPage = () => {
    const navigate = useNavigate();
    const { isAuth, isLoading, checkAuth } = useAuth();
    const [authStatus, setAuthStatus] = useState('checking'); // checking, success, error
    const [statusMessage, setStatusMessage] = useState('Проверяем авторизацию...');

    useEffect(() => {
        console.log('🔍 TelegramEntryPage mounted');

        // Детальная отладка окружения
        console.log('🌐 Environment details:', {
            userAgent: navigator.userAgent,
            url: window.location.href,
            windowTelegram: !!window.Telegram,
            isFromTelegram: /Telegram/.test(navigator.userAgent),
            referrer: document.referrer
        });

        // Проверяем, есть ли Telegram WebApp
        if (window.Telegram && window.Telegram.WebApp) {
            const tg = window.Telegram.WebApp;

            // Очень детальные логи
            console.log('🎯 Telegram WebApp детали:', {
                initData: tg.initData || 'ПУСТО',
                initDataLength: tg.initData ? tg.initData.length : 0,
                initDataUnsafe: tg.initDataUnsafe || 'ПУСТО',
                platform: tg.platform || 'НЕИЗВЕСТНО',
                version: tg.version || 'НЕИЗВЕСТНО',
                isExpanded: tg.isExpanded,
                viewportHeight: tg.viewportHeight,
                viewportStableHeight: tg.viewportStableHeight,
                headerColor: tg.headerColor,
                backgroundColor: tg.backgroundColor,
                isVersionAtLeast6: tg.isVersionAtLeast ? tg.isVersionAtLeast('6.0') : 'НЕТ ФУНКЦИИ',
                url: window.location.href
            });

            // Показываем эту информацию пользователю для отладки
            setStatusMessage(`🔍 Отладка: platform=${tg.platform}, version=${tg.version}, initData=${tg.initData ? `${tg.initData.length} символов` : 'ПУСТО'}`);

            // Настраиваем WebApp для лучшей работы
            try {
                tg.ready();
                tg.expand();

                // Попытка включить полноэкранный режим (для новых версий)
                if (tg.isVersionAtLeast && tg.isVersionAtLeast('6.0') && tg.requestFullscreen) {
                    console.log('🔄 Пытаемся включить полноэкранный режим...');
                    tg.requestFullscreen().catch(err => console.log('❌ Не удалось включить полноэкранный режим:', err));
                }

                // Устанавливаем цвета
                if (tg.setHeaderColor) {
                    tg.setHeaderColor('#1a1a2e');
                }
                if (tg.setBackgroundColor) {
                    tg.setBackgroundColor('#0f0f1e');
                }
            } catch (error) {
                console.log('⚠️ Ошибки настройки WebApp:', error);
            }

            // Пытаемся авторизоваться если есть initData
            if (tg.initData && tg.initData.trim() !== '') {
                setStatusMessage('✅ initData найден! Авторизуемся...');
                attemptTelegramAuth(tg.initData);
            } else {
                // На ПК initData может быть недоступен - это нормально
                console.log('⚠️ initData недоступен - возможно ПК версия Telegram');

                if (tg.initDataUnsafe && tg.initDataUnsafe.user) {
                    console.log('🔧 initDataUnsafe доступен, пытаемся fallback авторизацию:', tg.initDataUnsafe);
                    setStatusMessage('🔧 Используем fallback авторизацию для ПК...');
                    attemptTelegramFallbackAuth(tg.initDataUnsafe.user);
                } else {
                    setAuthStatus('error');
                    setStatusMessage('❌ Данные для авторизации недоступны. Возможно, это старая версия Telegram или ПК клиент без поддержки WebApp авторизации.');
                }
            }
        } else {
            console.log('❌ Telegram WebApp не обнаружен на странице /tg');

            // Возможно пользователь открыл ссылку не из Telegram
            if (!/Telegram/.test(navigator.userAgent)) {
                setAuthStatus('error');
                setStatusMessage('❌ Эта страница должна быть открыта из Telegram WebApp. Откройте ссылку через нашего Telegram бота.');
            } else {
                setAuthStatus('error');
                setStatusMessage('❌ Telegram WebApp API недоступен. Обновите Telegram до последней версии.');
            }
        }
    }, []);

    useEffect(() => {
        // Если пользователь уже авторизован, перенаправляем на главную
        if (!isLoading && isAuth) {
            console.log('✅ Пользователь авторизован, перенаправляем на главную');
            setAuthStatus('success');
            setStatusMessage('Авторизация успешна! Перенаправляем...');
            setTimeout(() => {
                navigate('/');
            }, 1000);
        }
    }, [isAuth, isLoading, navigate]);

    const attemptTelegramAuth = async (initData) => {
        try {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            
            // Получаем реферальную ссылку из cookies или URL
            const refId = new URLSearchParams(window.location.search).get("ref") || Cookies.get("ref_id");
            
            console.log('📡 Отправляем запрос на /api/auth/telegram-webapp');
            console.log('📦 initData length:', initData.length);
            console.log('🔗 Ref ID:', refId);

            const response = await fetch('/api/auth/telegram-webapp', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ initData, timezone, ref: refId })
            });

            const data = await response.json();
            console.log('📨 Ответ сервера:', data);

            if (data.success) {
                console.log('✅ Telegram авторизация успешна');
                setStatusMessage('Авторизация успешна! Загружаем профиль...');
                // Принудительно проверяем авторизацию
                await checkAuth();
            } else {
                console.log('❌ Ошибка авторизации:', data);
                setAuthStatus('error');
                setStatusMessage(`Ошибка авторизации: ${data.message || 'Неизвестная ошибка'}`);
            }
        } catch (error) {
            console.error('💥 Ошибка запроса авторизации:', error);
            setAuthStatus('error');
            setStatusMessage('Ошибка соединения с сервером.');
        }
    };

    const attemptTelegramFallbackAuth = async (userInfo) => {
        try {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            
            // Получаем реферальную ссылку из cookies или URL
            const refId = new URLSearchParams(window.location.search).get("ref") || Cookies.get("ref_id");

            console.log('📡 Отправляем fallback запрос на /api/auth/telegram-webapp-fallback');
            console.log('📦 User info:', userInfo);
            console.log('🔗 Ref ID:', refId);

            const response = await fetch('/api/auth/telegram-webapp-fallback', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ user_info: userInfo, timezone, ref: refId })
            });

            const data = await response.json();
            console.log('📨 Ответ fallback сервера:', data);

            if (data.success) {
                console.log('✅ Telegram fallback авторизация успешна');
                setStatusMessage('Fallback авторизация успешна! Загружаем профиль...');
                // Принудительно проверяем авторизацию
                await checkAuth();
            } else {
                console.log('❌ Ошибка fallback авторизации:', data);
                setAuthStatus('error');
                setStatusMessage(`Ошибка fallback авторизации: ${data.message || 'Неизвестная ошибка'}`);
            }
        } catch (error) {
            console.error('💥 Ошибка fallback запроса авторизации:', error);
            setAuthStatus('error');
            setStatusMessage('Ошибка соединения с сервером при fallback авторизации.');
        }
    };

    return (
        <div className="text-page">
            <div className="text-page-container">
                {authStatus === 'checking' && (
                    <>
                        <h1>🔄 Загрузка</h1>
                        <p>{statusMessage}</p>
                        <div style={{ textAlign: 'center', margin: '20px 0' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                border: '4px solid #f3f3f3',
                                borderTop: '4px solid #3498db',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite',
                                margin: '0 auto'
                            }}></div>
                        </div>
                    </>
                )}

                {authStatus === 'success' && (
                    <>
                        <h1>🎉 Успешно!</h1>
                        <p>{statusMessage}</p>
                        <div style={{
                            background: '#1a4d3a',
                            border: '1px solid #2d5a47',
                            borderRadius: '8px',
                            padding: '20px',
                            margin: '20px 0',
                            textAlign: 'center'
                        }}>
                            <h3 style={{ color: '#4ade80', margin: '0 0 10px 0' }}>
                                🎮 Добро пожаловать в ONCASPIN!
                            </h3>
                            <p style={{ color: '#86efac', margin: 0 }}>
                                Ваш аккаунт готов к игре
                            </p>
                        </div>
                    </>
                )}

                {authStatus === 'error' && (
                    <>
                        <h1>❌ Ошибка</h1>
                        <p>{statusMessage}</p>
                        <div style={{
                            background: '#4a1a1a',
                            border: '1px solid #5a2d2d',
                            borderRadius: '8px',
                            padding: '20px',
                            margin: '20px 0'
                        }}>
                            <h3 style={{ color: '#f87171', margin: '0 0 10px 0' }}>
                                🛠 Что делать?
                            </h3>
                            <ul style={{ color: '#fca5a5', textAlign: 'left', margin: 0 }}>
                                <li>Убедитесь, что запускаете из нашего Telegram бота</li>
                                <li>Попробуйте перезапустить приложение</li>
                                <li>Обратитесь в поддержку если проблема повторяется</li>
                            </ul>
                        </div>
                        <button
                            className="btn sign-up"
                            onClick={() => window.location.href = getApiUrl()}
                            style={{ marginTop: '20px' }}
                        >
                            Перейти на сайт
                        </button>
                    </>
                )}
            </div>

            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default TelegramEntryPage;
